const B = {
  "lincolnville-sc": {
    intro: [
      "Lincolnville is a small, historic town founded by freedmen after the Civil War, tucked between Summerville and Ladson with deep roots and quiet streets. Its longtime homes and family properties often need a good clear out.",
      "Skedaddle hauls furniture, appliances and full cleanouts throughout Lincolnville, honoring the town's history with careful, respectful work. Friendly service and fair pricing always.",
    ],
    neighborhoods: [
      ["Historic Lincolnville", "the founding town center"],
      ["Broadway Street", "old family homes"],
      ["Church Street", "near the historic churches"],
      ["Highway 78 corridor", "in town cottages"],
      ["Ellis Street", "quiet residential"],
      ["Dunmeyer Hill", "established lots"],
      ["Lincolnville Road", "the main artery"],
      ["Summers Drive", "family streets"],
      ["Magnolia area", "wooded lots"],
      ["Ladson edge", "toward the fairgrounds"],
      ["Summerville edge", "near the town line"],
      ["Sawmill Branch area", "along the creek"],
      ["Old Orangeburg Road", "country edges"],
      ["Ridge Street", "small lot homes"],
      ["Town limits", "the tight knit core"],
    ],
  },
  "johns-island-sc": {
    intro: [
      "Johns Island is the biggest island in the Lowcountry, a mix of ancient oaks, working farms and fast growing subdivisions along Maybank Highway and River Road. From farmhouses to new builds, there is plenty to haul.",
      "Skedaddle clears garages, hauls furniture and manages full cleanouts across Johns Island, comfortable on the long country roads and the newer neighborhoods alike. Fast and friendly, island style.",
    ],
    neighborhoods: [
      ["Maybank Highway corridor", "the island's main road"],
      ["Fenwick Hall", "near the historic plantation"],
      ["The Preserve at Fenwick", "newer gated homes"],
      ["Stonoview", "waterfront community with a dock"],
      ["Kiawah River", "upscale riverside living"],
      ["Whitney Lake", "homes around the lake"],
      ["St Johns Crossing", "family subdivision"],
      ["Marsh View", "quiet marsh front lots"],
      ["Angel Oak area", "near the famous tree"],
      ["River Road", "farms and country homes"],
      ["Headquarters Plantation", "gated near the bridge"],
      ["Twelve Oaks", "newer family homes"],
      ["Swygerts Landing", "waterfront adjacent"],
      ["Cedar Springs", "wooded newer builds"],
      ["Bohicket area", "toward Seabrook"],
      ["Hollywood edge", "rural southwest"],
    ],
  },
  "james-island-sc": {
    intro: [
      "James Island is Charleston's laid back neighbor, close to Folly Beach with a friendly mix of ranches, bungalows and newer homes among the marshes. It is one of our busiest island stops for cleanouts.",
      "Skedaddle hauls furniture, appliances, yard debris and full cleanouts across James Island, and we know every shortcut around Folly Road and Camp Road. Quick to arrive, easy to work with.",
    ],
    neighborhoods: [
      ["Riverland Terrace", "oak lined streets and the boat landing"],
      ["Central Park", "near the county park"],
      ["Stiles Point", "waterfront homes"],
      ["Lighthouse Point", "harbor and marsh views"],
      ["Clark Sound", "quiet marsh front lots"],
      ["Ocean Neighbors", "family friendly streets"],
      ["Whitehouse Plantation", "established homes"],
      ["Fort Johnson Estates", "near the marine lab"],
      ["Bayview Farms", "amenity rich community"],
      ["Parrot Point", "waterfront adjacent"],
      ["Country Club area", "golf course streets"],
      ["Secessionville", "historic waterfront corner"],
      ["Battery Island", "tucked marsh lots"],
      ["Camp Road corridor", "central and convenient"],
      ["Honey Hill", "quiet residential"],
      ["Grimball Road area", "toward the sound"],
    ],
  },
  "folly-beach-sc": {
    intro: [
      "Folly Beach, the Edge of America, is a breezy barrier island of surf shacks, beach cottages and vacation rentals. Salt air is hard on furniture, and turnovers happen often, so we stay busy hauling here.",
      "Skedaddle handles beach house cleanouts, old furniture and rental turnovers across Folly Beach, working around the narrow lanes and busy summer crowds. Fast and friendly with sand between our toes.",
    ],
    neighborhoods: [
      ["Center Street", "the walkable beach strip"],
      ["East Ashley Avenue", "cottages toward the county park"],
      ["West Ashley Avenue", "rentals toward the lighthouse view"],
      ["The Washout", "the famous surf break area"],
      ["Little Oak Island", "gated bridge community"],
      ["Sunset Point", "river side homes"],
      ["Folly River side", "marsh and dock lots"],
      ["Second Block", "near the pier"],
      ["North Folly", "quieter residential end"],
      ["South Folly", "toward the county park"],
      ["Huron Avenue", "beach cottages"],
      ["Erie Avenue", "vacation rentals"],
      ["Arctic Avenue", "the oceanfront row"],
      ["Center Street businesses", "shops and eateries"],
      ["Folly Road gateway", "coming onto the island"],
    ],
  },
  "isle-of-palms-sc": {
    intro: [
      "Isle of Palms is a polished barrier island of beach homes, resort villas and family getaways just past Mount Pleasant. Between rentals turning over and homes being refreshed, there is always something to clear.",
      "Skedaddle hauls furniture, appliances and full cleanouts across Isle of Palms, working neatly around the resort areas and residential lanes. Quick, courteous and upfront.",
    ],
    neighborhoods: [
      ["Front Beach", "the lively oceanfront strip"],
      ["Wild Dunes", "gated resort community"],
      ["Ocean Boulevard", "beachfront homes"],
      ["Palm Boulevard", "the island's spine"],
      ["The Links", "golf villas at Wild Dunes"],
      ["Grand Pavilion", "resort core"],
      ["Forest Trail", "wooded interior lots"],
      ["Waterway Boulevard", "intracoastal side homes"],
      ["Marina area", "boats and docks"],
      ["Beachwood", "family cottages"],
      ["Sea Cove", "quiet residential"],
      ["Cameron Boulevard", "coming onto the island"],
      ["41st Avenue area", "central beach access"],
      ["Hartnett Boulevard", "residential lane"],
      ["Intracoastal side", "waterway views"],
    ],
  },
  "sullivans-island-sc": {
    intro: [
      "Sullivan's Island is a historic, low key barrier island of stately beach homes, Fort Moultrie and that famous lighthouse. Its cherished homes are often refreshed, and that is where we come in.",
      "Skedaddle hauls old furniture, appliances and full cleanouts across Sullivan's Island, treating these special properties with care. Friendly, careful and always upfront on price.",
    ],
    neighborhoods: [
      ["Fort Moultrie area", "historic waterfront"],
      ["Middle Street", "the walkable village center"],
      ["Station 22 area", "beach access streets"],
      ["Station 18", "residential beach lanes"],
      ["Station 26", "toward Breach Inlet"],
      ["Breach Inlet", "near the channel"],
      ["I'On Avenue", "grand beach homes"],
      ["Atlantic Avenue", "oceanfront row"],
      ["Marshall Boulevard", "harbor side"],
      ["Osceola Avenue", "residential lane"],
      ["Raven Drive", "quiet streets"],
      ["Poe Avenue", "named for the writer"],
      ["Thompson Avenue", "central island"],
      ["Conquest Avenue", "beach cottages"],
      ["Lighthouse area", "near the historic beacon"],
    ],
  },
  "kiawah-island-sc": {
    intro: [
      "Kiawah Island is a world famous resort island of championship golf, gated luxury homes and pristine beaches. High end villas and homes here see frequent refreshes and turnovers.",
      "Skedaddle handles furniture removal, appliance pickup and full cleanouts across Kiawah, working discreetly and neatly in these exclusive communities. Professional service, upfront pricing.",
    ],
    neighborhoods: [
      ["Kiawah Island Club area", "premier private community"],
      ["Ocean Park", "newer oceanfront neighborhood"],
      ["Cassique", "golf and marsh homes"],
      ["The Settlement", "central resort area"],
      ["Vanderhorst", "gated eastern end"],
      ["West Beach", "villas near the inn"],
      ["East Beach", "resort villas and shops"],
      ["Turtle Point", "golf course homes"],
      ["Osprey Point", "lagoon side living"],
      ["Cougar Point", "golf villas"],
      ["Governors Club", "established homes"],
      ["Sandcastle area", "beachfront community"],
      ["Rhetts Bluff", "riverfront lots"],
      ["Falcon Point", "quiet cul de sacs"],
      ["Freshfields edge", "toward the village shops"],
    ],
  },
  "seabrook-island-sc": {
    intro: [
      "Seabrook Island is a private, gated barrier island of golf, equestrian trails and quiet natural beauty next to Kiawah. Its homes and villas are lovingly kept and periodically cleared out.",
      "Skedaddle hauls old furniture, appliances and full cleanouts across Seabrook Island, working carefully within the gated community. Courteous, tidy and upfront every time.",
    ],
    neighborhoods: [
      ["Seabrook Island Club", "the private community core"],
      ["Ocean Winds", "golf course villas"],
      ["Crooked Oaks", "the other championship course"],
      ["Pelican Watch", "beachfront villas"],
      ["Beach Club Villas", "near the ocean"],
      ["High Hammock", "wooded interior homes"],
      ["Jenkins Point", "riverfront luxury lots"],
      ["The Haulover", "marsh side living"],
      ["Bohicket Marina edge", "boats and dining nearby"],
      ["Live Oak", "quiet streets"],
      ["Marsh Gate", "near the entrance"],
      ["Fiddlers Marsh", "tidal creek lots"],
      ["Green Winged Teal", "villa cluster"],
      ["Sora Rail", "residential lane"],
      ["Andell edge", "toward Freshfields Village"],
    ],
  },
  "wadmalaw-island-sc": {
    intro: [
      "Wadmalaw Island is a rural gem of oak canopies, tomato fields, the Charleston Tea Garden and Deep Water Vineyard. Its farmsteads and country homes call for hauling that is not afraid of a dirt drive.",
      "Skedaddle clears sheds, hauls old furniture and manages full property cleanouts across Wadmalaw Island. Long country roads are no trouble for our crew.",
    ],
    neighborhoods: [
      ["Maybank Highway corridor", "the island's main road"],
      ["Charleston Tea Garden area", "near the tea fields"],
      ["Deep Water Vineyard area", "by the winery"],
      ["Rockville", "historic waterfront village"],
      ["Bears Bluff", "along the road to the ferry site"],
      ["Martins Point", "waterfront country lots"],
      ["Little Rock", "rural community"],
      ["Liberia", "historic settlement area"],
      ["Sandy Point", "marsh front homes"],
      ["Cherry Point", "boat landing area"],
      ["Yonges Island edge", "toward the neighbor island"],
      ["Legareville Road", "farm country"],
      ["Toogoodoo edge", "deep rural lots"],
      ["Church Creek side", "tidal water access"],
      ["Island interior", "scattered homesteads"],
    ],
  },
  "edisto-island-sc": {
    intro: [
      "Edisto Island is a timeless, unhurried barrier island of beach houses, marsh views and Spanish moss, a bit further down the coast in Colleton County. Beach homes and rentals here need regular clearing.",
      "Skedaddle makes the drive to Edisto to haul furniture, appliances and full beach house cleanouts. Worth the trip and always friendly, that is our promise.",
    ],
    neighborhoods: [
      ["Edisto Beach", "the classic beachfront town"],
      ["Palmetto Boulevard", "the oceanfront row"],
      ["Jungle Road", "central beach access"],
      ["Wyndham Ocean Ridge", "gated resort community"],
      ["Fairfield Ocean Ridge", "golf and villas"],
      ["Bay Creek area", "marsh side lots"],
      ["Edingsville Beach area", "quiet stretch"],
      ["Peters Point", "waterfront country lots"],
      ["Steamboat Landing", "boat access"],
      ["Sunnyside", "historic island area"],
      ["Middleton", "rural interior"],
      ["Point of Pines", "historic settlement"],
      ["Botany Bay edge", "near the preserve"],
      ["Big Bay", "marsh front homes"],
      ["Highway 174 corridor", "the road onto the island"],
    ],
  },
  "awendaw-sc": {
    intro: [
      "Awendaw is a quiet coastal community north of Mount Pleasant along Highway 17, bordered by the Francis Marion Forest and the marshes of Bulls Bay. Country homes and forest edge properties keep us hauling out here.",
      "Skedaddle clears sheds, hauls old furniture and manages full cleanouts across Awendaw, comfortable on the rural roads and wooded lots. Fast, friendly and upfront.",
    ],
    neighborhoods: [
      ["Highway 17 corridor", "the coastal main road"],
      ["Seewee area", "near the visitor center"],
      ["Bulls Bay", "marsh and creek front"],
      ["Awendaw Creek", "waterfront country lots"],
      ["Doar Point", "quiet residential"],
      ["Rembert", "wooded forest edge"],
      ["Tibwin", "near the historic plantation land"],
      ["McClellanville edge", "toward the fishing village"],
      ["Francis Marion Forest edge", "deep woods lots"],
      ["Steed Creek Road", "rural homesteads"],
      ["Sewee Preserve area", "protected land border"],
      ["Copahee Sound side", "marsh views"],
      ["Fifteen Mile Landing", "boat access"],
      ["Awendaw Green area", "the community gathering spot"],
      ["Guerin Bridge Road", "country lane"],
    ],
  },
  "mcclellanville-sc": {
    intro: [
      "McClellanville is a picture perfect fishing village of shrimp boats, live oaks and porch swings up near the Santee Delta. Its historic homes and waterfront camps sometimes need a thorough clear out.",
      "Skedaddle makes the trip up Highway 17 to haul furniture, appliances and full cleanouts in McClellanville. We treat this special little town with the care it deserves.",
    ],
    neighborhoods: [
      ["Village center", "the historic waterfront core"],
      ["Pinckney Street", "oak shaded old homes"],
      ["Jeremy Creek", "shrimp docks and camps"],
      ["Oakland", "near the historic plantation"],
      ["Rutledge Road", "country lots"],
      ["Buck Hall area", "forest recreation edge"],
      ["Germantown", "rural community"],
      ["Honey Hill", "deep forest homesteads"],
      ["Silver Hill", "wooded rural lots"],
      ["Cape Romain side", "toward the refuge"],
      ["Highway 45 corridor", "country road homes"],
      ["Sewee Road", "toward Awendaw"],
      ["Santee Delta edge", "marsh and river"],
      ["St James Santee area", "historic parish land"],
      ["Village outskirts", "quiet edges"],
    ],
  },
  "ravenel-sc": {
    intro: [
      "Ravenel is a rural crossroads town southwest of Charleston along Highway 17, known for the Cooper River bridge run finish it is not, but for its farms, country homes and the county detention center. Country properties here keep us busy.",
      "Skedaddle hauls furniture, appliances, yard debris and full cleanouts throughout Ravenel and the surrounding countryside. No dirt road is too far for our crew.",
    ],
    neighborhoods: [
      ["Highway 17 corridor", "the main crossroads"],
      ["Ravenel town center", "the small town core"],
      ["Parkers Ferry Road", "country homesteads"],
      ["Toogoodoo area", "along the tidal creek"],
      ["Jacksonboro edge", "toward the ACE Basin"],
      ["Meggett edge", "neighbor farm country"],
      ["Wallace School Road", "rural lane"],
      ["Highway 165 corridor", "country road homes"],
      ["Bears Bluff Road edge", "toward Wadmalaw"],
      ["Pinckney Colony", "historic settlement"],
      ["Willtown edge", "along the Edisto"],
      ["Adams Run edge", "deep rural"],
      ["Caw Caw area", "near the interpretive center"],
      ["Stono side", "river access lots"],
      ["Town outskirts", "scattered farmsteads"],
    ],
  },
  "hollywood-sc": {
    intro: [
      "Hollywood is a quiet rural town southwest of Charleston, full of farms, forests and country homesteads near the Stono and the ACE Basin. Its spread out properties call for hauling that goes the distance.",
      "Skedaddle clears sheds, hauls old furniture and manages full property cleanouts across Hollywood. We are happy to make the country drive and keep the price honest.",
    ],
    neighborhoods: [
      ["Highway 162 corridor", "the town's main road"],
      ["Hollywood town center", "the small community core"],
      ["Meggett edge", "neighbor farm country"],
      ["Poplar Grove", "gated riverfront community"],
      ["Stono Ferry", "golf and equestrian homes"],
      ["The Ponds edge", "toward Summerville"],
      ["Parkers Ferry", "rural homesteads"],
      ["Toogoodoo Road", "along the creek"],
      ["Lowcountry Highway", "country lane homes"],
      ["Chapman Road", "wooded lots"],
      ["Willtown Bluff edge", "along the Edisto"],
      ["Rantowles", "near the creek and marsh"],
      ["New Road area", "farm country"],
      ["Sandy Point", "waterfront lots"],
      ["Town outskirts", "scattered farmsteads"],
    ],
  },
  "meggett-sc": {
    intro: [
      "Meggett is a tiny, tranquil town in rural Charleston County, once a bustling produce shipping hub and now a peaceful stretch of farms and waterfront country homes near the Wadmalaw and Toogoodoo. Out here, cleanouts mean country drives, and we are glad to make them.",
      "Skedaddle hauls furniture, appliances, sheds and full property cleanouts throughout Meggett and the surrounding farmland. Friendly, fast and never afraid of a long dirt drive.",
    ],
    neighborhoods: [
      ["Meggett town center", "the quiet crossroads core"],
      ["Highway 165 corridor", "the main country road"],
      ["Toogoodoo Road", "along the tidal creek"],
      ["Wadmalaw side", "toward the island"],
      ["Yonges Island edge", "neighbor farm country"],
      ["Meggett Park area", "near the county park"],
      ["Old Meggett", "historic produce town remnants"],
      ["Ravenel edge", "toward the crossroads"],
      ["Willtown Road", "along the Edisto"],
      ["Parkers Ferry edge", "deep rural lots"],
      ["Church Flats", "farm country"],
      ["Hyde Park Road", "wooded homesteads"],
      ["Bear Swamp area", "back country lots"],
      ["Rantowles edge", "near the creek"],
      ["Town outskirts", "scattered farmsteads"],
    ],
  },
};
export default B;
